import React from 'react';
import { Edit } from 'react-admin';
import HelpForm from './form';

const HelpEdit = (props) => {
  const { resource } = props;
  return (
    <Edit
      mutationMode="optimistic"
      title={`resources.${resource}.titles.edit`}
      {...props}
    >
      <HelpForm />
    </Edit>
  );
};

export default HelpEdit;
